<template>
  <div class="row pt-3">
    <div class="col">
     <h2 class="mb-0">Başvuru Formu</h2>
    </div>
    <div class="menu" style="  width: 100px;">
      <p>
      <a href="/kitap-listesi">Kitap Listesi</a>
    </p>
    </div>
     <div class="col-md-12 mb-5"><hr></div>
  
    </div>
  <div class="row pt-3">
    <TextForm label="İsim" v-model="isim" col="md-6 mb-4"/>
    <TextForm label="Soyisim" v-model="soyisim" col="md-6 mb-4"/>
    <TextForm label="Mail Adresiniz" v-model="mail" col="md-6 mb-4"/>
    <TextForm label="Cep Telefonu Numaranız" v-model="tel" col="md-6 mb-4" placeholder="Örn:5325555555"/>
    <TextForm label="Adres" v-model="adres" col="md-8 mb-4"/>
    <SelectForm label="Ada Seçin" v-model="uye_ada" :optarr="ada_listesi" opt_name="adi" opt_value="id"  col="md-4" form_class="col-md-4 mb-4"/>
    <div class="col-md-12">
    <hr>
    <div class="mb-3">
      <label for="exampleFormControlTextarea1" class="form-label">ÜYELİK SÖZLEŞMESİ</label>
      <iframe src="https://kutuphane.adalarmuzesi.org/kvkk.html" frameborder="0"></iframe>
     
    </div>
    <hr>
    <div class="form-check">
  <input class="form-check-input" type="checkbox" value="" id="flexCheckDefault" v-model="onayli">
  <label class="form-check-label sozlesmecheck" for="flexCheckDefault">
    Üyelik Sözleşmesini okudum, anladım ve kabul ediyorum!
  </label>
</div>

  </div>
<div class="col-md-12 d-flex justify-content-end">

  <ButonIcon v-if="onayli && !wait" value="Kabul Ediyorum" size="" ikon="check" colortype="info"  @click="this.gonder()" />
  <ButonIcon v-if="onayli && wait" value="Lütfen Bekleyin!" size="" ikon="check" colortype="info"   />
  <ButonIcon v-if="!onayli" value="Kabul Ediyorum" size="" ikon="check" colortype="disabled" @click="this.uyari"   disabled />
</div>

</div>
</template>

<script>
import TextForm from '@/components/FormText.vue'
import SelectForm from '@/components/FormSelect.vue'
import ButonIcon from '@/components/ButonIkonlu.vue'
import adalar from '@src/ada_listesi.json'
import harfdenetim from '@src/harfdenetim.js'
import axios from 'axios'
import Swal from 'sweetalert2/dist/sweetalert2.js'
import 'sweetalert2/dist/sweetalert2.min.css'
export default {
  name: 'HomeView',
  data () {
          return {
            ada_listesi:adalar,
            onayli:false,
            isim:'',
            soyisim:'',
            mail:'',
            tel:'',
            adres:'',
            uye_ada:'',
            islem_url:'https://api2.adalarvakfi.org/kutuphane/uye_kaydet.php',
            wait:false,
          }
          },
  components: {

    TextForm,
    SelectForm,
    ButonIcon
  },
  watch: {
      isim: { handler: function (val, oldVal) { if(oldVal != null){ this.kayit_uyari = true } this.isim = harfdenetim.methods.harf_bhb(val) }, deep: true },
      soyisim: { handler: function (val, oldVal) { if(oldVal != null){ this.kayit_uyari = true } this.soyisim = harfdenetim.methods.harf_bhb(val) }, deep: true },
      mail: { handler: function (val, oldVal) { if(oldVal != null){ this.kayit_uyari = true } this.mail = harfdenetim.methods.harf_k(val) }, deep: true },
  },
  methods:{
    uyari:function(){
      var mail_kontrol_reg = new RegExp(/^[^0-9][a-zA-z0-9_]+([.][a-zA-z0-9_]+)*[@][a-zA-z0-9_]+([.][a-zA-z0-9_]+)*[.][a-zA-Z]{2,4}$/i);
      var mail_kontrol = mail_kontrol_reg.test(this.mail)
      if(this.isim.length < 2){
        Swal.fire({ title:'Lütfen Dikkat',text: "İsim en az iki harften oluşmalıdır.",icon: 'warning', confirmButtonText:'Kapat'})
      } 
      else if(this.soyisim.length < 2){
        Swal.fire({ title:'Lütfen Dikkat',text: "Soyisim en az iki harften oluşmalıdır.",icon: 'warning', confirmButtonText:'Kapat'})
      }
      else if(!mail_kontrol){
        Swal.fire({ title:'Lütfen Dikkat',text: "Mail adresinizde bir hata var lütfen kontrol edin!",icon: 'warning', confirmButtonText:'Kapat'})
      } 
      else if(this.tel.length !== 10 ) {
        Swal.fire({ title:'Lütfen Dikkat',text: "Cep telefonu mumaranız 5325555555 şeklinde 10 haneli olmalıdır. ",icon: 'warning', confirmButtonText:'Kapat'})
      } 
      else if(this.adres.length < 7){
        Swal.fire({ title:'Lütfen Dikkat',text: "Adresiniz en az 7 karakterden oluşmalıdır, lütfen kontrol edin!",icon: 'warning', confirmButtonText:'Kapat'})
      }
      else if(this.uye_ada.length < 1){
        Swal.fire({ title:'Lütfen Dikkat',text: "Ada Seçmelisiniz, lütfen kontrol edin!",icon: 'warning', confirmButtonText:'Kapat'})
      }
      
     else if(!this.onayli ) {
        Swal.fire({ title:'Lütfen Dikkat',text: "\"Üyelik Sözleşmesini okudum, anladım ve kabul ediyorum!\" yazan kutuyu işretlemisiniz!",icon: 'warning', confirmButtonText:'Kapat'})
      }
    },
    gonder:function(){
      var mail_kontrol_reg = new RegExp(/^[^0-9][a-zA-z0-9_]+([.][a-zA-z0-9_]+)*[@][a-zA-z0-9_]+([.][a-zA-z0-9_]+)*[.][a-zA-Z]{2,4}$/i);
      var mail_kontrol = mail_kontrol_reg.test(this.mail)
      if(this.isim.length < 2){
        Swal.fire({ title:'Lütfen Dikkat',text: "İsim en az iki harften oluşmalıdır.",icon: 'warning', confirmButtonText:'Kapat'})
      } 
      else if(this.soyisim.length < 2){
        Swal.fire({ title:'Lütfen Dikkat',text: "Soyisim en az iki harften oluşmalıdır.",icon: 'warning', confirmButtonText:'Kapat'})
      }
      else if(!mail_kontrol){
        Swal.fire({ title:'Lütfen Dikkat',text: "Mail adresinizde bir hata var lütfen kontrol edin!",icon: 'warning', confirmButtonText:'Kapat'})
      } 
      else if(this.tel.length !== 10 ) {
        Swal.fire({ title:'Lütfen Dikkat',text: "Cep telefonu mumaranız 5325555555 şeklinde 10 haneli olmalıdır. ",icon: 'warning', confirmButtonText:'Kapat'})
      } 
      else if(this.adres.length < 7){
        Swal.fire({ title:'Lütfen Dikkat',text: "Adresiniz en az 7 karakterden oluşmalıdır, lütfen kontrol edin!",icon: 'warning', confirmButtonText:'Kapat'})
      }
      else if(this.uye_ada.length < 1){
        Swal.fire({ title:'Lütfen Dikkat',text: "Ada Seçmelisiniz, lütfen kontrol edin!",icon: 'warning', confirmButtonText:'Kapat'})
      }
     else if(!this.onayli ) {
        Swal.fire({ title:'Lütfen Dikkat',text: "\"Üyelik Sözleşmesini okudum, anladım ve kabul ediyorum!\" yazan kutuyu işretlemisiniz!",icon: 'warning', confirmButtonText:'Kapat'})
      }
      else {

        this.wait = true;

        const formData = new FormData()
            formData.append('isim', this.isim)
            formData.append('soyisim', this.soyisim)
            formData.append('mail',this.mail)
            formData.append('tel',this.tel)
            formData.append('adres',this.adres)
            formData.append('ada_id',this.uye_ada)

            axios({
                method: 'post',
                responseType: 'json',
                url: this.islem_url,
                data: formData
            }).then((response) => {
              console.log(response)
                if(response.data.hata){
                // alert(response.data.cevap);
                Swal.fire({
                    title: 'Hata',
                    text: response.data.cevap,
                    icon: 'warning',
                })
                //console.log(response.data)
                } else {
                  Swal.fire({
                    title: 'Teşekkürler',
                    text: response.data.cevap,
                    icon: 'success',
                })
                this.isim=""
                this.soyisim=""
                this.mail=""
                this.tel=""
                this.adres=""
                this.ada_id=""
                this.wait = false;

                }
            })



      }

    }
  }
}
</script>

<style>

.menu p a{
  color: rgb(0, 34, 155);
  text-decoration: none;
  font-size: 0.95rem;
  font-weight: 700;
}
.container{
  max-width: 800px !important;
}
iframe{
  width: 100%;
  scrollbar-width: 20px;
}
.sozlesmecheck{
  color: red;
  font-size: 1rem;
}

input[type="checkbox"]{
  border-color: red;
}

</style>